import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Offers = lazy(() => import("@/pages/Offers"));

export const Route = createFileRoute("/_public/offers")({
  component: Offers,
});
